import { useCallback } from 'react';
import { Field } from '@oscar/form';
import { Button, Col, DatePicker, Modal, Radio, Row } from '@oscar/theme';
import { FORMAT_DATE } from 'common/constants';
import moment from 'moment';
import { useState } from 'react';
import './styles.scss';
import { DatePickerPopulate } from 'common/components';
import { handleValidateChecklist } from 'views/pages/utils';

const textOption: [string, string][] = [
  ['typeOfInsulation', 'Type of insulation as per specification'],
  [
    'thicknessOfInsulation',
    'Thickness of insulation material as per specification',
  ],
  ['claddingInUse', 'Cladding in use as per specification'],
  [
    'conditionOfInsulationMaterial',
    'Condition of insulation material is acceptable as per specification',
  ],
  [
    'insulationMaterialInstall',
    'Insulation material install as per insulation repair procedure',
  ],
  [
    'insulationMaterialProperlySecured',
    'Insulation material properly secured with ss wire strip or band',
  ],

  ['sealant', 'Sealant is applied,adequate and acceptable'],
  ['noPhysicalDamageOrPenetration', 'No physical damage or penetration'],
  ['noBulgingOrWetInsulation', 'No bulging or wet insulation'],
  ['noRetainingBands', 'No retaining bands missing/broken'],
  ['aluminiumTapeBeingUsed', 'Aluminium tape being used?'],
  ['housekeepingCompliant', 'Housekeeping compliant'],
];

const OPTIONS: { label: string; value: any }[] = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
  { label: 'N/A', value: '' },
];
const OPTIONS_AR: { label: string; value: any }[] = [
  { label: 'Accepted', value: true },
  { label: 'Rejected', value: false },
];

type CheckListProps = {
  value: Record<string, any>;
  onChange?: (value: Record<string, any>) => void;
  data: [string, string][];
  options: { label: string; value: any }[];
};

const GroupCheckList: React.FC<CheckListProps> = ({
  value,
  onChange,
  data,
  options,
}) => {
  const [selectedValue, setSelectedValue] = useState(value || {});

  const handleChange = useCallback(
    (optionKey: string, optionValue: any) => {
      const changed = {
        ...selectedValue,
        [optionKey]: optionValue,
      };
      setSelectedValue(changed);
      onChange?.(changed);
    },
    [data, selectedValue],
  );

  return (
    <>
      {data.map((item: any) => {
        return (
          <div key={item?.[0]}>
            <Row className="reinstate-item" gutter={12}>
              <Col span={12}>
                <span>{item?.[1]}</span>
              </Col>
              <Col span={12}>
                <Radio.Group
                  onChange={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleChange(item?.[0], e.target.value);
                  }}
                  value={selectedValue[item?.[0]]}
                >
                  {options.map(option => {
                    return <Radio value={option.value}>{option.label}</Radio>;
                  })}
                </Radio.Group>
              </Col>
            </Row>
          </div>
        );
      })}
    </>
  );
};

interface Props {
  onClose: () => void;
  visible: boolean;
  value?: any;
  onChange?: (value: any) => void;
  startDate?: string;
  endDate?: string;
}

const ReinstatementChecklist = ({
  onClose,
  visible,
  value,
  onChange,
  startDate,
  endDate,
}: Props) => {
  const [currentValue, setCurrentValue] = useState({
    ...value,
    overallAcceptance: value?.overallAcceptance,
    inspectionDate: value?.inspectionDate,
  });
  const [checkList, setCheckList] = useState({});

  const handleChange = useCallback(
    selected => {
      setCheckList(selected);
    },
    [currentValue],
  );

  const handleDateChange = (date: any) => {
    setCurrentValue({
      ...currentValue,
      inspectionDate: date,
    });
  };

  function disabledDate(current: any) {
    return (
      current &&
      current.valueOf() < moment(startDate, FORMAT_DATE.FULL_DATETIME)
    );
  }

  return (
    <div className="reinstate-checklist">
      <Modal
        closable={false}
        bodyStyle={{ width: '100%' }}
        visible={visible}
        title="Reinstatement Checklist"
        okText="Confirm"
        cancelText="Cancel"
        onCancel={() => onClose()}
        onOk={() => {
          onChange?.({ ...checkList, ...currentValue });
          onClose();
        }}
        okButtonProps={{
          disabled: handleValidateChecklist(
            { ...checkList, ...currentValue },
            textOption,
          ),
        }}
        width={600}
      >
        <GroupCheckList
          value={currentValue}
          data={textOption}
          options={OPTIONS}
          onChange={handleChange}
        />

        <Row className="reinstate-acept" gutter={12}>
          <Col span={12}>
            <span className="label-bold">Overall Acceptance</span>
          </Col>
          <Col span={12}>
            <Radio.Group
              options={OPTIONS_AR}
              value={currentValue?.overallAcceptance}
              onChange={e => {
                setCurrentValue({
                  ...currentValue,
                  overallAcceptance: e.target.value,
                });
              }}
            />
          </Col>
        </Row>
        <Row className="reinstate-acept" gutter={12}>
          <Col span={24}>
            <p className="label-normal">Inspection Date</p>
            <DatePickerPopulate
              className="date-picker"
              placeholder=""
              inputReadOnly={true}
              onChange={handleDateChange}
              disabledDate={disabledDate}
              format={FORMAT_DATE.SHORT_MONTH_DATE}
              value={currentValue?.inspectionDate}
            />
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default ReinstatementChecklist;
